import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

const AdminLoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login, user, isAuthenticated } = useAuth();

  useEffect(() => {
    // Redirect if already authenticated as super admin
    if (isAuthenticated && user) {
      if (user.role === 'super_admin' || user.role === 'super-admin') {
        navigate('/admin/super');
      } else {
        // Non-super-admin users go to business portal
        navigate('/admin/business');
      }
    }
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
      // API returns role, navigation happens via useEffect
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Invalid admin credentials');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src="/logo.png" alt="LinkPerks" />
          </div>
        </div>
        <div className="login-body">
          <h1 className="login-title">LinkPerks Super Admin</h1>
          <p className="login-subtitle">Administrator Access Only</p>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter admin email"
                required
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                required
                disabled={isLoading}
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="login-button super-admin" disabled={isLoading}>
              {isLoading ? 'Signing In...' : 'Admin Sign In'}
            </button>
          </form>

          <div className="login-footer">
            <p className="admin-notice">⚠️ Super admin access only. If you're a business user, <a href="/admin/login">sign in here</a>.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;

